import { render } from "./DefaultLoader.vue?vue&type=template&id=b0f0c6a2&scoped=true"
import script from "./DefaultLoader.vue?vue&type=script&lang=js"
export * from "./DefaultLoader.vue?vue&type=script&lang=js"

import "./DefaultLoader.vue?vue&type=style&index=0&id=b0f0c6a2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0f0c6a2"]])

export default __exports__